<template>
   <el-form ref="form" :rules="rules" :model="currForm" label-width="80px" label-position="left">
      <el-form-item label="名称" prop="name">
         <el-input :disabled="!edit" style="width: 300px" placeholder="最多20个字" v-model="currForm.name"></el-input>
         <span v-if="currForm.id">当前装配人数：{{ currForm.countUsed }}</span>
      </el-form-item>

      <el-form-item label="宣传图" prop="publicityPicture">
         <div>
            <UploadImg :imgUrl.sync="currForm.homeRunSkinModel.publicityPicture" :disabled="edit" />
            <div class="tips">（尺寸：120*120，jpg、png）</div>
         </div>
      </el-form-item>

      <el-form-item label="展示图" prop="displayPicture">
         <div class="bezel-list">
            <div class="bezel-item">
               <div>跑步GO</div>
               <UploadImg :imgUrl.sync="currForm.homeRunSkinModel.runGo" :disabled="edit" />
               <div class="tips">（尺寸：130*130，jpg、png）</div>
            </div>
            <div class="bezel-item">
               <div>滑动开启跑步</div>
               <UploadImg :imgUrl.sync="currForm.homeRunSkinModel.slideStart" :disabled="edit" />
               <div class="tips">（尺寸：100*100，jpg、png）</div>
            </div>
            <div class="bezel-item">
               <div>跑步未达标</div>
               <UploadImg :imgUrl.sync="currForm.homeRunSkinModel.endScoreNoReach" :disabled="edit" />
               <div class="tips">（尺寸：120*120，jpg、png）</div>
            </div>
            <div class="bezel-item">
               <div>跑步达标</div>
               <UploadImg :imgUrl.sync="currForm.homeRunSkinModel.endScoreReach" :disabled="edit" />
               <div class="tips">（尺寸：120*120，jpg、png）</div>
            </div>
         </div>
      </el-form-item>

      <el-form-item label="展示排序" prop="sort">
         <el-input-number :min="0" :disabled="!edit" v-model="currForm.sort"></el-input-number>
         <div>数字越大越靠前</div>
      </el-form-item>
      <el-form-item label="拥有学生">
         <SelectStudent ref="SelectStudentRef" :disabled="edit" :selectVal.sync="currForm.useType"
            :privileges="currForm.privilegeRole">
         </SelectStudent>
      </el-form-item>
      <el-form-item label="角标图片">
         <SUpload
            v-model="currForm.superscript"
            accept="image/*"
            type="drag"
            :size="50"
            :disabled="!edit"
            :show-file-list="false"
         />
         <div class="tips">尺寸建议40*40，最大50KB，优先SVG其次png</div>
      </el-form-item>
   </el-form>
</template>

<script>
import UploadImg from "../../../../../components/common/UploadImg.vue";
import SelectStudent from "./SelectStudent.vue";

export default {
   components: {
      UploadImg,
      SelectStudent,
   },

   props: {
      form: {
         type: Object,
         default: () => ({}),
      },
      edit: {
         type: Boolean,
         default: true,
      },
   },

   data() {
      // 验证宣传图
      var validatePublicityPicture = (rule, value, callback) => {
         if (this.currForm.homeRunSkinModel.publicityPicture === "") {
            callback(new Error("请上传宣传图"));
         } else {
            callback();
         }
      };
      // 验证展示图
      var validateDisplayPicture = (rule, value, callback) => {
         callback();
         return;
         if (this.currForm.homeRunSkinModel.runGo === "") {
            callback(new Error("请上传跑步GO展示图"));
         } else if (this.currForm.homeRunSkinModel.slideStart === "") {
            callback(new Error("请上传滑动开启跑步展示图"));
         } else if (this.currForm.homeRunSkinModel.endScoreReach === "") {
            callback(new Error("请上传跑步未达标展示图"));
         } else if (this.currForm.homeRunSkinModel.endScoreNoReach === "") {
            callback(new Error("请上传跑步达标展示图"));
         } else {
            callback();
         }
      };
      return {
         currForm: {
            useType: 0,
            homeRunSkinModel: {
               publicityPicture: "",
               runGo: "",
               slideStart: "",
               endScoreReach: "",
               endScoreNoReach: "",
            },
         },
         rules: {
            name: [{ required: true, message: "请输入名称", trigger: "blur" }],
            publicityPicture: [
               {
                  required: true,
                  validator: validatePublicityPicture,
                  trigger: "blur",
               },
            ],
            displayPicture: [
               {
                  required: false,
                  validator: validateDisplayPicture,
                  trigger: "change",
               },
            ],
            sort: [
               {
                  required: true,
                  type: "number",
                  message: "请输入排序",
                  trigger: "change",
               },
            ],
         },
      };
   },

   watch: {
      form: {
         handler(newValue, oldVal) {
            if (newValue.homeRunSkinModel) {
               this.currForm = JSON.parse(JSON.stringify(newValue));
            }
            this.currForm.useType = newValue.useType;
            this.currForm.businessType = newValue.businessType;
            this.currForm.status = newValue.status;
         },
         deep: true,
         immediate: true,
      },
   },

   methods: {
      // 保存
      submit(release = false) {
         this.$refs.form.validate(async (valid) => {
            if (valid) {
               const uids = this.$refs.SelectStudentRef.selectItemList.map(
                  (item) => item.uid
               );
               const params = {
                  name: this.currForm.name,
                  useType: this.currForm.useType,
                  sort: this.currForm.sort,
                  homeRunSkinModel: this.currForm.homeRunSkinModel,
                  businessType: this.currForm.businessType,
                  status: this.currForm.status,
                  superscript: this.currForm.superscript,
               };
               if (this.currForm.useType === 1) {
                  params.uids = uids;
               } else if (this.currForm.useType === 2) {
                  params.privilegeRole = this.$refs.SelectStudentRef.selectPrivileges.join(',');
               }
               if (this.currForm.id) {
                  params.id = this.currForm.id;
               }
               const res = await this.$http({
                  url:
                     this.$util.domain +
                     "/adminapi/v1/personalizedComponents/addOrEdit",
                  method: "post",
                  body: JSON.stringify(params),
               });
               if (res.data.error === 10000) {
                  if (release) {
                     const response = await this.$http({
                        url:
                           this.$util.domain +
                           "/adminapi/v1/personalizedComponents/change",
                        method: "get",
                        params: {
                           id: res.data.data,
                           status: 3,
                        },
                     });
                     if (response.data.error === 10000) {
                        this.$message.success("操作成功");
                        this.$router.push("/yunying/userDiyPage");
                     } else {
                        this.$message.error(response.data.message || "操作失败");
                     }
                  } else {
                     this.$message.success("操作成功");
                     this.$router.push("/yunying/userDiyPage");
                  }
               } else {
                  this.$message.error(res.data.message || "操作失败");
               }
            } else {
               console.log("error submit!!");
               return false;
            }
         });
      },
   },
};
</script>

<style scoped>
.bezel-list {
   margin-top: 10px;
   display: flex;
   flex-direction: row;
   align-items: center;
}

.bezel-item {
   margin-top: -30px;
   margin-right: 10px;
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
}
</style>


// WEBPACK FOOTER //
// RunningSkin.vue?eee12ae8